import React from 'react'
import _ from 'lodashParts'
import Button from './button.jsx'
import symbols from './symbols'

class IconButton extends React.Component {
    constructor(props) {
        super(props)
        this.execCommand = () => this.props.execCommand(this.props.cmdName)
    }

    render() {
        const self = this
        function drawSymbol() {
            if (self.props.symbol) {
                return (
                    <svg className="symbol" {...symbols[self.props.symbol].svg}
                         dangerouslySetInnerHTML={{__html: symbols[self.props.symbol].content}}>
                    </svg>
                )
            }

            return null
        }
        return (
            <Button style={this.props.style} className={this.props.className} onClick={() => this.props.onClick()} disabled={this.props.disabled} automationId={this.props.automationId}>
                {drawSymbol()}
                {this.props.children}
            </Button>
        )
    }
}

IconButton.defaultProps = {
    onClick: _.noop,
    disabled: false
}

IconButton.propTypes = {
    onClick: React.PropTypes.func,
    disabled: React.PropTypes.bool,
    symbol: React.PropTypes.string
}

module.exports = IconButton



// WEBPACK FOOTER //
// ./src/components/toolbar/iconButton.jsx